import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  FunnelChart,
  Tooltip,
  Funnel as ReFunnel,
  LabelList,
} from "recharts";
import randomColor from "randomcolor";
import { useStyles } from "./styles";
import { colors } from "./colors";
import { map } from "lodash";

export function Funnel({ width = "100%", data }) {
  const styles = useStyles();

  const newData = useMemo(() => {
    return map(data, (dt) => ({
      fill: randomColor({ luminosity: "light", hue: colors[0] }),
      ...dt,
      ...(dt?.value === 0 ? { value: 1 } : {}),
    }));
  }, [data]);

  return (
    <div className={styles.root}>
      <ResponsiveContainer height="100%" width="50%">
        {/*@ts-ignore*/}
        <FunnelChart width={width}>
          <Tooltip
            payload={data}
            formatter={(value, name, { payload: { payload } }) => [
              Boolean(payload.percentual)
                ? `${payload.value} | ${payload.percentual}%`
                : value,
              name,
            ]}
          />
          <ReFunnel dataKey="value" data={newData} isAnimationActive>
            <LabelList
              position="right"
              fill="#000"
              stroke="none"
              dataKey="name"
            />
          </ReFunnel>
        </FunnelChart>
      </ResponsiveContainer>
    </div>
  );
}
